import { createReducer } from '@reduxjs/toolkit';
import { DeepWritable } from 'ts-essentials';

import { AppSearchParams } from 'utils/url/useAppSearchParams';

import { conversationsActions } from './conversations.actions';

type ConversationsState = {
  /** The last search params used to read conversations. */
  lastSearchParams: AppSearchParams<'/conversations'>;
};

const initialState: ConversationsState = {
  lastSearchParams: {
    status: ['open'],
  },
};

export const conversationsReducer = createReducer(initialState, (builder) =>
  builder.addCase(conversationsActions.setLastSearchParams, (state, action) => {
    state.lastSearchParams = action.payload as DeepWritable<
      AppSearchParams<'/conversations'>
    >;
  }),
);
